import { ComponentProps } from './LoginPage';
import React from 'react';

const RegistrationApproval: React.FC<ComponentProps> = ({ setActiveComponent }) => {
  return (
    <div className="p-5 leading-4">
      <div className="h-[90vh] d-flex align-items-center ">
        <div>
          <p className="text-xl text-red">Successfully Signed up</p>
          <p className="text-base leading-6 opacity-80">
            You have been successfully signed up to Spotlock. To continue, please login.
          </p>

          <a className="text-purple text-sm" href="/login" onChange={() => setActiveComponent('Login')}>
            Go to Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegistrationApproval;
